module.exports = __webpack_public_path__ + "static/octin-stencil-rg-subset-3cd875f8b5c030659e601f992ae91102.woff";